import { Component } from '@angular/core';

import { LocaleDirective } from '../../directives/locale.directive';

@Component({
    selector: 'module-disabled',
    templateUrl: 'module-disabled.component.html',
    imports: [LocaleDirective],
})
export class ModuleDisabledComponent {}
